import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Col, Row, Button, Form, FormGroup, Label } from 'reactstrap';
import { validateSecurityDetails } from './helper';

//for configuring security details like purge duration for corporates
class SecurityDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMsg: ''
        }
    }

    saveSecurityDetails(event) {
        let msg = validateSecurityDetails(this.props.SecurityDetails.values['purgeDuration']);
        if (msg != '') {
            this.setState({
                errorMsg: msg
            })
        } else {
            this.setState({
                errorMsg: ''
            }, () => { this.props.saveSecurityDetailsCallback(event, this.props.SecurityDetails.values, true); })

        }

        event.preventDefault();
    }
    render() {
        return (
            <Form>
                <FormGroup className="mb-4">
                    <Label for="purge-duration">Purge Duration<span className="text-danger">*</span></Label>
                    <Field name="purgeDuration" component="input" type="number" placeholder="Purge Duration in Days" className='mb3 form-control' />
                </FormGroup>
                <FormGroup>
                    <Button type="submit" className="d-block ml-auto" color="primary" onClick={(event) => this.saveSecurityDetails(event)}>Save</Button>
                </FormGroup>
                <div className='error'>{this.state.errorMsg}</div>
            </Form>
        )
    }

}

SecurityDetails = reduxForm({
    form: 'SecurityDetailsForm',
    enableReinitialize: true
})(SecurityDetails)



const mapStateToProps = (state, ownProps) => ({
    SecurityDetails: state.form.SecurityDetailsForm,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
});

export default SecurityDetails = connect(
    mapStateToProps,
    mapDispatchToProps
)(SecurityDetails)